RivalIQ.apps.Shell.module('behaviors', function (behaviors, App, Backbone, Marionette, $, _) {

    'use strict';

    behaviors.MenuItem = Marionette.Behavior.extend({
        events: {
            click: 'onClick'
        },

        defaults: {
            className: 'current'
        },

        onRender: function () {

            const me = this;

            if (me.isActive()) {

                me.$el.addClass(me.options.className);
            }
        },

        onClick: function (e) {

            const me = this;
            const view = me.view;

            if (me.$el.hasClass('disabled') || me.$el.hasClass('no-click')) {
                e.preventDefault();
                e.stopPropagation();
                return;
            }

            if (!e.metaKey) {
                view.triggerMethod('activated');
            }
        },

        isActive: function () {

            const me = this;
            const view = me.view;
            const options = view.options;

            const result = Boolean(options.active);

            return result;
        }
    });

});
